/* Einblenden beim Scrollen (nur Startseite): sichtbar als Standard, Bewegung nur wenn erlaubt. */
(function () {
  var items = document.querySelectorAll('.fgh-reveal');
  if (!items.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach(function (e) { e.classList.add('fgh-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('fgh-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  items.forEach(function (e) { io.observe(e); });
})();

/*
 * Charm-Check (Charm-Baukasten der Startseite): Zweite, unabhängige Aufzeichnung der Charm-Auswahl an der Klammerzeile
 * (Eigenschaft mit Unterstrich, nur im Admin sichtbar): "Kein Charm gewählt" oder "2 Charms gewählt: Perle, Star".
 * Greift nur direkt nach einem Tipp auf "In den Warenkorb legen" im Baukasten.
 */
(function () {
  var root = document.querySelector('[data-fgh-builder]');
  if (!root) return;
  var KEY = '_Charm-Check', stamp = 0;
  function names() {
    var r = [];
    root.querySelectorAll('[data-sel] .nm').forEach(function (e) { r.push(e.textContent.trim()); });
    return r;
  }
  function text(list) {
    return list.length ? list.length + (list.length === 1 ? ' Charm' : ' Charms') + ' gewählt: ' + list.join(', ') : 'Kein Charm gewählt';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-fgh-builder] [data-add]')) stamp = Date.now();
  }, true);
  var orig = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (stamp && Date.now() - stamp < 2000 && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
        var b = JSON.parse(init.body);
        if (b && b.items && b.items.length) {
          var p = b.items[0].properties || {};
          p[KEY] = text(names());
          b.items[0].properties = p;
          init.body = JSON.stringify(b);
        }
        stamp = 0;
      }
    } catch (err) {}
    return orig.apply(this, arguments);
  };
})();
